import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/hooks/useAuth';

const socialLinks = [
  { name: 'Twitter', icon: 'ri-twitter-x-line', url: 'https://twitter.com/baga-tech' },
  { name: 'LinkedIn', icon: 'ri-linkedin-line', url: 'https://linkedin.com/company/baga-tech' },
  { name: 'Telegram', icon: 'ri-telegram-line', url: 'https://t.me/baga-tech' },
];

const footerLinks = [
  {
    title: 'Ürün',
    links: [
      { label: 'Özellikler', url: '/product', isLive: false },
      { label: 'Fiyatlandırma', url: '/pricing', isLive: false },
      { label: 'Canlı Kararlar', url: '#', isLive: true },
    ],
  },
  {
    title: 'Şirket',
    links: [
      { label: 'Hakkımızda', url: '/about', isLive: false },
      { label: 'Blog', url: '/blog', isLive: false },
      { label: 'İletişim', url: 'mailto:info@baga-tech.com', isLive: false },
    ],
  },
  {
    title: 'Destek',
    links: [
      { label: 'Yardım Merkezi', url: '/help', isLive: false },
      { label: 'SSS', url: '/#faq', isLive: false },
      { label: 'İletişim', url: 'mailto:info@baga-tech.com', isLive: false },
    ],
  },
];

const Footer = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleLiveClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (token) {
      window.location.href = `https://live.baga-tech.com/auth/supabase?token=${token}`;
    } else {
      navigate('/auth');
    }
  };

  return (
    <footer className="bg-gradient-to-b from-dark-lighter to-dark border-t border-dark-border">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <a href="/" className="flex items-center gap-3 mb-6 group cursor-pointer">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald to-emerald-light rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <i className="ri-line-chart-line text-xl text-dark"></i>
              </div>
              <span className="text-2xl font-bold text-beige-light">BAGA</span>
            </a>
            <p className="text-beige mb-6 leading-relaxed">
              Yapay zeka destekli algoritmik karar sistemi ile yatırımlarınızı güvenle yönetin.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-dark-card border border-dark-border rounded-lg flex items-center justify-center text-beige hover:text-emerald hover:border-emerald/50 transition-all duration-300 cursor-pointer"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          {footerLinks.map((column) => (
            <div key={column.title}>
              <h3 className="text-lg font-bold text-beige-light mb-6">{column.title}</h3>
              <ul className="space-y-4">
                {column.links.map((link) => (
                  <li key={link.label}>
                    {link.isLive ? (
                      <button
                        onClick={handleLiveClick}
                        className="text-beige hover:text-emerald transition-colors duration-300 cursor-pointer bg-transparent border-none p-0 text-left"
                      >
                        {link.label}
                      </button>
                    ) : (
                      <a
                        href={link.url}
                        className="text-beige hover:text-emerald transition-colors duration-300 cursor-pointer"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-dark-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-beige text-sm">
            © 2023-2026 BAGA Tech. Tüm hakları saklıdır.
          </p>
          <div className="flex gap-6">
            <a href="/privacy" className="text-beige hover:text-emerald transition-colors text-sm cursor-pointer">
              Gizlilik Politikası
            </a>
            <a href="/terms" className="text-beige hover:text-emerald transition-colors text-sm cursor-pointer">
              Kullanım Koşulları
            </a>
          </div>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-beige hover:text-emerald transition-colors text-sm cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
